<template>
  <v-layout align-center justify-center align-content-center>
    <modal
      name="errorModal"
      :draggable="!isMobile"
      :clickToClose="false"
      :height="modalHeight"
      :width="modalWidth"
    >
      <v-toolbar color="#00558C" dark>
        <v-toolbar-title>Error</v-toolbar-title>
      </v-toolbar>
      <v-card-subtitle>
        Something went wrong. Please try again. If the error persists, please
        contact support.
      </v-card-subtitle>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#00558C" dark @click="$modal.hide('errorModal')"
          >OK</v-btn
        >
      </v-card-actions>
    </modal>

    <div :class="$vuetify.breakpoint.smAndUp ? 'drop page-spacer' : 'drop'">
      <span v-if="$vuetify.breakpoint.xs">
        <v-layout justify-center align-content-center align-center column>
          <v-icon color="green" size="100">mdi-account</v-icon>
          <v-layout justify-center align-content-center align-center column>
            <v-card-title
              style="color: #00558c; font-weight: bold; text-align: center"
              >Admin User Management</v-card-title
            >
            <v-card-subtitle style="text-align: center"
              >Add, Modify, Activate &amp; Inactivate Admin
              Users.</v-card-subtitle
            >
          </v-layout>
        </v-layout> </span
      ><span v-else>
        <v-layout justify-center align-content-center align-center row>
          <v-icon color="green" size="100">mdi-account</v-icon>
          <span>
            <v-card-title
              style="color: #00558c; font-weight: bold; text-align: center"
              >Admin User Management</v-card-title
            >
            <v-card-subtitle
              >Add, Modify, Activate &amp; Inactivate Admin
              Users.</v-card-subtitle
            >
          </span>
        </v-layout>
      </span>
      <br /><br /><br />
      <!-- 
      <v-layout justify-center align-content-center align-center>
        <v-card-text>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            style="margin-left: 40px"
          ></v-text-field>
        </v-card-text>
      </v-layout> -->
      <v-data-table
        :headers="headers"
        dense
        :items="wait ? [] : adminUsersFiltered"
        :no-data-text="wait ? 'Please wait...' : 'No Admin Users Found.'"
        item-key="FederationID"
        class="elevation-4"
        :loading="wait"
        sort-by="CreatedDate"
        :sort-desc="true"
        mobile-breakpoint="960"
      >
        <template v-slot:[`item.AgentAdminStatusCode`]="{ item }">
          {{ item.AgentAdminStatusCode | status }}
        </template>

        <template v-slot:[`item.UpdatedDate`]="{ item }">
          {{ item.UpdatedDate | mmddyyyy }}
        </template>

        <template v-slot:[`item.CreatedDate`]="{ item }">
          {{ item.CreatedDate | mmddyyyy }}
        </template>

        <template v-slot:[`item.edit`]="{ item }">
          <v-tooltip top color="green" dark>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" @click="editItem(item)">mdi-lead-pencil</v-icon>
            </template>
            <span>Edit</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <v-progress-circular
        indeterminate
        color="green"
        v-if="waitCircle"
        size="50"
        class="waitCircle"
      ></v-progress-circular>
      <br />
      <br />
      <!-- <v-btn
          color="green"
          class="menuBtn"
          dark
          @click="$router.push('/')"
          style="margin-right: 10px"
          >Return to Main Menu</v-btn
        > -->
      <span v-if="$vuetify.breakpoint.xs">
        <v-layout column align-center align-content-center>
          <v-btn
            width="200"
            color="green"
            dark
            class="menuBtn"
            @click.stop="refresh"
            >Refresh</v-btn
          >
          <br />
          <v-btn
            width="200"
            color="green"
            v-if="!hide"
            dark
            class="menuBtn"
            @click.stop="hide = !hide"
            >Hide Failed</v-btn
          >
          <v-btn
            width="200"
            color="green"
            v-if="hide"
            dark
            class="menuBtn"
            @click.stop="hide = !hide"
            >Show All</v-btn
          >
          <br />
          <v-btn
            width="200"
            color="green"
            dark
            class="menuBtn"
            @click.stop="gotoCreateUser"
            >Create User</v-btn
          >
          <br /><br /><br /><br /><br />
        </v-layout> </span
      ><span v-else>
        <v-layout justify-end align-content-end align-end>
          <v-btn color="green" dark class="menuBtn" @click.stop="refresh"
            >Refresh</v-btn
          >
          <v-btn
            color="green"
            v-if="!hide"
            dark
            class="menuBtn btn-spacer"
            @click.stop="hide = !hide"
            >Hide Failed</v-btn
          >
          <v-btn
            color="green"
            v-if="hide"
            dark
            class="menuBtn btn-spacer"
            @click.stop="hide = !hide"
            >Show All</v-btn
          >

          <v-btn
            color="green"
            dark
            class="menuBtn btn-spacer"
            @click.stop="gotoCreateUser"
            >Create User</v-btn
          >
        </v-layout>
        <br /><br /><br /><br /><br /><br />
      </span>
    </div>
  </v-layout>
</template>
<script>
import EventBus from "@/eventBus.js";
import utilityMixins from "@/utility-mixins.js";
import { HTTP_GAP } from "@/http-common.js";

export default {
  mixins: [utilityMixins],
  computed: {
    modalWidth() {
      return this.$vuetify.breakpoint.xs ? "300" : "450";
    },
    modalHeight() {
      return this.$vuetify.breakpoint.xs ? "225" : "200";
    },
    adminUsersFiltered() {
      if (this.hide) {
        return this.adminUsers.filter(au => au.AgentAdminStatusCode != "F");
      }

      return this.adminUsers;
    },
    calcWidth() {
      return window.innerWidth - 200;
    },
    tmkClientId() {
      return window.sessionStorage.getItem("tmkClientId");
    }
  },
  created() {
    if (
      this.tmkClientId == null ||
      this.tmkClientId == undefined ||
      this.tmkClientId == ""
    ) {
      this.$router.push("/unauthenticated");
    } else {
      this.makeAxiosCall();
      this.isMobileCheck();
      window.addEventListener("resize", this.isMobileCheck);
    }
  },
  mounted() {
    EventBus.$on(
      "closeCreateUser",
      function() {
        this.dialog = false;
      }.bind(this)
    );
  },
  beforeDestroy() {
    EventBus.$off("closeCreateUser");
    EventBus.$off("userChange");
  },
  data() {
    return {
      hide: false,
      search: null,
      dialog: false,
      waitCircle: false,
      wait: false,
      firstName: "",
      middleName: "",
      lastName: "",
      address: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      phone: "",
      email: "",
      adminUsers: [],
      headers: [
        {
          text: "User ID",
          value: "FederationID",
          sortable: true
        },
        {
          text: "First Name",
          value: "FirstName",
          sortable: true
        },
        {
          text: "Last Name",
          value: "LastName",
          sortable: true
        },
        {
          text: "Status",
          value: "AgentAdminStatusCode",
          sortable: true
        },
        {
          text: "Created On",
          value: "CreatedDate",
          sortable: true
        },
        {
          text: "Last Updated",
          value: "UpdatedDate",
          sortable: true
        },

        { text: "Edit", value: "edit", sortable: false }
      ]
    };
  },
  methods: {
    makeAxiosCall() {
      this.wait = true;
      HTTP_GAP.get("ReadAgentAdmin", {
        params: {
          AssociatedAgentTMKClientID: window.sessionStorage.getItem(
            "tmkClientId"
          )
        }
      })
        .then(results => {
          if (results.status == 200) {
            this.adminUsers = results.data;
            this.wait = false;
          } else {
            this.waitCircle = false;
            this.$modal.show("errorModal");
          }
        })
        .catch(e => {
          this.wait = false;
          this.$modal.show("errorModal");
          this.addToErrorLogs("UserManagement.vue mounted ReadAgentAdmin", e);
        });
    },
    refresh() {
      if (
        !window.sessionStorage.getItem("tmkClientId") ||
        window.sessionStorage.getItem("tmkClientId") == ""
      )
        return false;

      this.wait = true;
      this.adminUsers = [];

      HTTP_GAP.get("ReadAgentAdmin", {
        params: {
          AssociatedAgentTMKClientID: window.sessionStorage.getItem(
            "tmkClientId"
          )
        }
      })
        .then(results => {
          if (results.status == 200) {
            this.adminUsers = results.data;
            this.wait = false;
          } else {
            this.waitCircle = false;
            this.$modal.show("errorModal");
          }
        })
        .catch(e => {
          this.wait = false;
          this.$modal.show("errorModal");

          this.addToErrorLogs("UserManagement.vue refresh ReadAgentAdmin", e);
        });
    },
    Status(agentStatus) {
      switch (agentStatus) {
        case "A":
          return "Active";
        case "I":
          return "Inactive";
        case "F":
          return "Failed";
        case "P":
          return "Pending";
        default:
          return "Unknown";
      }
    },
    editItem(item) {
      let edit = item;
      this.waitCircle = true;

      HTTP_GAP.get("ReadIndividual", {
        params: {
          AssociatedAgentTMKClientID: window.sessionStorage.getItem(
            "tmkClientId"
          ),
          FederationID: item.FederationID
        }
      })
        .then(results => {
          if (results.status == 200) {
            edit = results.data[0];
            this.waitCircle = false;
            this.$router.push({
              name: "User",
              params: {
                user: edit,
                mode: "Update"
              }
            });
          } else {
            this.waitCircle = false;
            this.$modal.show("errorModal");
          }
        })
        .catch(e => {
          this.waitCircle = false;
          this.$modal.show("errorModal");

          this.addToErrorLogs("UserManagement.vue editItem ReadIndividual", e);
        });
    },
    gotoCreateUser() {
      // this.dialog = true;
      this.$router.push({
        name: "User",
        params: {
          user: null,
          mode: "Create"
        }
      });
    }
  }
};
</script>
<style scoped>
.drop {
  margin-top: 75px;
  position: relative;
  overflow: hidden;
  min-height: 700px;
}
.page-spacer {
  margin-left: 50px;
  margin-right: 50px;
}
.waitCircle {
  z-index: 50;
  position: absolute;
  top: 25%;
  left: 47%;
}
</style>
<style>
.v-data-table-header-mobile__wrapper {
  margin-left: 50px;
}
.btn-spacer {
  margin-left: 10px;
}
</style>
